import React from 'react';
import { Box } from '@mui/material';

const SpacerBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const {
    height = 30,
    backgroundColor = 'transparent',
  } = data;

  const getResponsiveHeight = () => {
    switch (previewMode) {
      case 'mobile':
        return Math.max(height * 0.7, 10);
      case 'tablet':
        return Math.max(height * 0.85, 15);
      default:
        return height;
    }
  };

  return (
    <Box
      sx={{
        height: `${getResponsiveHeight()}px`,
        backgroundColor: isSelected ? '#f0f8ff' : backgroundColor,
        border: isSelected ? '1px dashed #007bff' : 'none',
        borderRadius: isSelected ? '4px' : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        color: '#999',
        position: 'relative',
        width: '100%',
        minHeight: '10px',
      }}
    >
      {isSelected && `Spacer: ${getResponsiveHeight()}px`}
    </Box>
  );
};

export default SpacerBlock; 